// extracted by mini-css-extract-plugin
module.exports = {"header":"Collapse_header__R5s5p","content":"Collapse_content__W4LhN","active":"Collapse_active__IHs52","fadeIn":"Collapse_fadeIn__uLczV"};